<template>
  <v-card :width="$vuetify.breakpoint.xs ? 260 : 320" :min-width="$vuetify.breakpoint.xs ? 260 : 320" light >
    <seo-v-img
      :src="thumbailImageSrc"
      :lazy-src="data.recordingYoutubeURL || data.recordingVimeoURL ? null : getMetaData(data.thumbnail)['image-lazy-src']"
      :aspect-ratio="16/9"
      :contain="!data.recordingYoutubeURL && !data.recordingVimeoURL"
      :cover="data.recordingYoutubeURL || data.recordingVimeoURL"
      width="100%"
      height="100%"
    >
      <v-row no-gutters align="center" justify="start" v-if="data.__typename === 'Talk'"><v-btn class="ma-2" icon @click="toggleFavorite" :loading="updatingUser"><v-icon color="white">{{isFavorite ? 'mdi-star': 'mdi-star-outline'}}</v-icon></v-btn></v-row>
    </seo-v-img>
    <v-card-text style="min-height: 150px;">
        <h2 class="text-h5 text-truncate">{{data.title}}</h2>
      <!-- <div class="subtitle-2 text-uppercase text-truncate font-weight-semibold">{{data.topics[0].title}}</div> -->
      <!-- <div class="subtitle-2 text-uppercase text-truncate font-weight-bold blue--text">{{data.tag || 'Talk'}}</div> -->
      <div style="min-height: 5.7rem;">
        <MarkdownBlock tag="p" inline class="ma-0 text-body-2 text-truncated-three-lines" :text="data.speakers" />
      </div>
    </v-card-text>

    <v-divider />
    <v-card-actions class="align-center justify-center pa-0">
      <template v-if="(!!data.recordingYoutubeURL || !!data.recordingVimeoURL) || isCurrentlyLive">

        <v-btn :x-large="!$vuetify.breakpoint.xs" :large="$vuetify.breakpoint.xs" v-if="!!data.recordingYoutubeURL || !!data.recordingVimeoURL" text tile :to="{name: 'EventRecording', params: {type: data.__typename, slug: data._slug}}" class="pr-md-4 px-0 grow px-md-1" >
          <v-icon >mdi-play</v-icon><span class="pl-2 font-weight-semibold d-inline-block text-truncate" style="max-width: calc(100% - 40px);" >Watch</span>
        </v-btn>

        <!-- <v-btn :x-large="!$vuetify.breakpoint.xs" :large="$vuetify.breakpoint.xs" v-else-if="isCurrentlyLive" text tile exact class="pr-md-4 px-0 grow px-md-1" :to="$route.name !== 'Home' ? {name: 'Home'} : null" @click="$route.name === 'Home' ? $vuetify.goTo(0) : null" >
          <v-icon >mdi-play</v-icon><span class="pl-2 font-weight-semibold d-inline-block text-truncate" style="max-width: calc(100% - 40px);">Watch</span>
        </v-btn> -->
        <v-divider vertical v-if="data.__typename === 'Talk'" />
      </template>
      <v-btn :x-large="!$vuetify.breakpoint.xs" :large="$vuetify.breakpoint.xs" text tile :to="{name: 'Calendar', params: {date: new Date(data.startingAt).toISOString().split('T')[0], talk: data._slug}}" class="px-0 px-md-1 grow" v-if="data.__typename === 'Talk'" >
        <v-icon >mdi-format-list-bulleted</v-icon><span class="pl-2 font-weight-semibold d-inline-block text-truncate" style="max-width: calc(100% - 40px);">About the talk</span>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import getVideoId from 'get-video-id'
import UpdateUser from '@/graphql/mutations/UpdateUser.gql'
import { MarkdownBlock } from '@monogrid/vue-lib'
import { optimizedImageURL, getMetaData, getAspectRatio } from '@/services/OptimizedImage'
import axios from 'axios'

export default {
  name: 'TalkCard',
  components: {
    MarkdownBlock
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      thumbailImageSrc: null,
      updatingUser: false
    }
  },
  mounted () {
    this.getThumbnailImageSrc()
  },
  watch: {
    data (value) {
      this.getThumbnailImageSrc()
    }
  },
  methods: {
    optimizedImageURL,
    getMetaData,
    getAspectRatio,
    getVideoId,
    async toggleFavorite () {
      this.updatingUser = true
      let favoriteTalks
      if (!this.isFavorite) {
        favoriteTalks = this.$root.databaseUser.favoriteTalks
          ? this.$root.databaseUser.favoriteTalks.map(t => `_reference/Talk/${t.id}`).concat([`_reference/Talk/${this.data.id}`])
          : [`_reference/Talk/${this.data.id}`]
      } else {
        favoriteTalks = this.$root.databaseUser.favoriteTalks.concat() // clone it
        const index = favoriteTalks.findIndex(t => t.id === this.data.id) // find index
        favoriteTalks.splice(index, 1) // Remove
        favoriteTalks = favoriteTalks.map(t => `_reference/Talk/${t.id}`) // replace objects with references
      }
      try {
        await this.$apollo.mutate({
          mutation: UpdateUser,
          variables: {
            id: this.$root.databaseUser.id,
            input: { favoriteTalks }
          }
        })
      } catch (e) {
        console.error(e)
      }
      this.updatingUser = false
    },
    async getThumbnailImageSrc () {
      if (this.data.recordingYoutubeURL) {
        this.thumbailImageSrc = `https://img.youtube.com/vi/${getVideoId(this.data.recordingYoutubeURL).id}/hqdefault.jpg`
        return
      } else if (this.data.recordingVimeoURL) {
        try {
          const result = await axios.get(`https://vimeo.com/api/oembed.json?url=${this.data.recordingVimeoURL}`)
          this.thumbailImageSrc = result.data.thumbnail_url
          return
        } catch (e) { console.error('Can\'t get thumbail url from vimeo, using CMS thumbnail') }
      }

      this.thumbailImageSrc = optimizedImageURL(this.data.thumbnail, { maxWidth: 400, aspectRatio: '16:9', fit: 'crop' })
    }
  },
  computed: {
    isFavorite () {
      return this.$root.databaseUser.favoriteTalks ? this.$root.databaseUser.favoriteTalks.findIndex(t => t.id === this.data.id) !== -1 : false
    },
    isCurrentlyLive () {
      const now = this.$root.getNow().getTime()
      const start = new Date(this.data.startingAt).getTime()
      const end = new Date(this.data.endingAt).getTime()
      return now >= start && now < end
    }
  }
}
</script>
